<template>
  <ul class="login-head">
    <li :class="{ 'active': !isRegisterTab }"
      @click="toLogin"
    >登录</li>
    <li :class="{ 'active': isRegisterTab }"
      @click="toRegister"
    >注册</li>
  </ul>
</template>

<script>
// import { ENV_API_HOST } from '../libs/constants';

export default {
  name: 'login-head',
  props: {
    env: { type: String, default: '' },
    isRegisterTab: { type: Boolean, default: false },
  },
  methods: {
    // 去登录
    toLogin() {
      this.$emit('changeLogin');
    },
    // 去注册
    toRegister() {
      this.$emit('changeRegister');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../libs/mixin.scss';

.login-head {
  text-align: center;
  margin-bottom: 60px;
  li {
    display: inline-block;
    position: relative;
    margin: 0 20px;
    padding: 8px 4px;
    font-size: 16px;
    font-weight: 500;
    color:rgba(102,102,102,1);
    line-height: 22px;
    cursor: pointer;
    &.active {
      font-size: 20px;
      color:rgba(51,51,51,1);
      line-height: 28px;
      &:after {
        position: absolute;
        left: 50%;
        bottom: 0;
        margin-left: -10px;
        content: '';
        display: inline-block;
        background-color: $mainColor;
        width:20px;
        height: 4px;
        border-radius:2px;
      }
    }
  }
}
</style>
